import { combineEpics } from 'redux-observable';
import { getArtistsEpic } from './get-artists';
import { setActiveEpic } from './set-active';
import { searchArtistsEpic } from './search-artists';
import { onboardArtistEpic } from './onboard-artist';
import { validateOnboardingEpic } from './validate-onboarding';
import { updateLastActiveArtistEpic } from './update-last-active';
import { updateArtistEpic } from './update-artist';
import { updateArtistListEpic } from './update-artist-list';
import { inviteAcceptedEpic } from './invite-accepted';
import { artistCreatedEpic } from './artist-created';
import { autosaveArtistPageEpic } from './autosave';
import { updateArtistPageEpic } from './update-artist-page';
import { getArtistPageEpic } from './get-artist-page';
import { getAchievementsEpic } from './get-achievements';
import { updateArtistDataOnPageEpic } from './update-artist-page-data';
import { publishArtistPageEpic } from './publish-artist-page';
import { searchExternalArtistsEpic } from './search-external-artists';
import { getActiveArtistTeamEpic } from './get-active-artist-team';
import { getArtistTeamEpic } from './get-artist-team';
import { getArtistsAfterDeactivateEpic } from './get-artists-after-deactivate';
import { deactivateArtistEpic } from './deactivate-artist';
import { deactivateArtistSuccessEpic } from './deactivate-artist-success';
import { updateArtistPlatformsEpic } from './update-artist-platforms';
import { updateArtistFirstLoginEpic } from './update-artist-first-login';
import { getAchievementsSuccessEpic } from './get-achievements-success';
import { updateAchievementEpic } from './update-achievement';
import { redirectToArtistProfileEpic } from './redirections-to-artist-profile';
import { getArtistTeamAfterDeleteMemberEpic } from './get-artist-team-after-delete-member';
import { removeFromArtistTeamEpic } from './remove-from-team';
import { switchArtistTeamMemberRoleEpic } from './switch-artist-team-member-role';
import { restoreDeactivatedArtistEpic } from './restore-deactivated-artist';
import { restoreDeactivatedArtistSuccessEpic } from './artist-restore-success';
import { validateExternalArtistIdEpic } from './validate-external-artist-id';

const artistEpic = combineEpics(
  getArtistsEpic,
  setActiveEpic,
  updateLastActiveArtistEpic,
  searchArtistsEpic,
  onboardArtistEpic,
  validateOnboardingEpic,
  updateArtistEpic,
  updateArtistListEpic,
  inviteAcceptedEpic,
  artistCreatedEpic,
  autosaveArtistPageEpic,
  updateArtistPageEpic,
  getArtistPageEpic,
  getAchievementsEpic,
  updateArtistDataOnPageEpic,
  publishArtistPageEpic,
  searchExternalArtistsEpic,
  getActiveArtistTeamEpic,
  getArtistTeamEpic,
  deactivateArtistEpic,
  deactivateArtistSuccessEpic,
  getArtistsAfterDeactivateEpic,
  updateArtistPlatformsEpic,
  updateArtistFirstLoginEpic,
  getAchievementsSuccessEpic,
  updateAchievementEpic,
  redirectToArtistProfileEpic,
  removeFromArtistTeamEpic,
  getArtistTeamAfterDeleteMemberEpic,
  switchArtistTeamMemberRoleEpic,
  restoreDeactivatedArtistEpic,
  restoreDeactivatedArtistSuccessEpic,
  validateExternalArtistIdEpic
);

export default artistEpic;
